import PropTypes from 'prop-types';
import styled from 'styled-components';
import AnimateHeight from 'react-animate-height';
import { Col, Row } from 'react-grid-system';
import r from 'render-dom';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    title: PropTypes.node,
};

const CardSection = styled.section`
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    box-shadow: 0px 3px 10px rgb(230 230 230 / 80%);
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 40px;
    padding: 30px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export default function Card({
    children = [],
    className,
    onClick = () => {},
    style = {},
    title,
}) {
    return (
        r(CardSection, { className, onClick, style }, [
            r(AnimateHeight, { duration: 333, height: 'auto' }, [
                r(Row, { isRendered: title }, [
                    r(Col, { xs: 10 }, [
                        title,
                    ]),
                ]),
                r.div([children]),
            ]),
        ])
    );
}

Card.propTypes = propTypes;
